import { createSlice } from "@reduxjs/toolkit";
import UserService from "Services/user";
import { AppThunk } from "../store/configureStore";

interface IAuthorizeState {
  isAuthenticated: boolean;
  isReadOnly: boolean;
  tokenExpiresIn: number;
  loginAt: number;
  logoutSuccess: boolean;
  loading: boolean;
  errors: any;
}

const initialState: IAuthorizeState = {
  isAuthenticated: UserService.isAuthenticated(),
  isReadOnly: UserService.isReadOnly(),
  tokenExpiresIn: UserService.tokenExpiresIn(),
  loginAt: UserService.loginAt(),
  logoutSuccess: false,
  loading: false,
  errors: {},
};

const authorizeSlice = createSlice({
  name: "authorize",
  initialState,
  reducers: {
    login: (state) => {
      state.logoutSuccess = false;
      state.isAuthenticated = true;
      state.tokenExpiresIn = UserService.tokenExpiresIn();
      state.loginAt = UserService.loginAt();
    },
    fetch: (state) => {
      state.loading = true;
    },
    setLogout: (state) => {
      state.isAuthenticated = false;
      state.isReadOnly = false;
      state.tokenExpiresIn = 0;
      state.logoutSuccess = true;
      state.loading = false;
    },
    setError: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.errors = payload;
    },
    setAutoLogin: (state) => {
      state.isReadOnly = true;
      state.isAuthenticated = true;
      state.tokenExpiresIn = UserService.tokenExpiresIn();
      state.loginAt = UserService.loginAt();
      state.loading = false;
    },
  },
});

export const {
  login,
  fetch,
  setError,
  setLogout,
  setAutoLogin,
} = authorizeSlice.actions;

export const logout = (): AppThunk => async (dispatch) => {
  dispatch(fetch());
  try {
    await UserService.logout();
    dispatch(setLogout());
  } catch (error) {
    dispatch(setError(error));
  }
};

export const autoLogin = (autoLoginData: any): AppThunk => async (dispatch) => {
  dispatch(fetch());
  try {
    await UserService.autoLogin(autoLoginData);
    dispatch(setAutoLogin());
  } catch (error) {
    dispatch(setError(error));
  }
};

export default authorizeSlice.reducer;
